import { Download, X, Share } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useInstallPrompt } from "@/hooks/use-install-prompt";
import { useIsMobile } from "@/hooks/use-mobile";

export function InstallPromptBanner() {
  const { canInstall, showIOSInstructions, install, dismiss } = useInstallPrompt();
  const isMobile = useIsMobile();

  // Desktop: subtle button shown in sidebar (rendered by Sidebar.tsx)
  // Mobile: slide-up banner from bottom
  if (!canInstall) return null;

  if (!isMobile) return null; // Desktop install button lives in Sidebar

  return (
    <div className="fixed bottom-20 left-4 right-4 z-40 rounded-2xl border border-border bg-card shadow-2xl p-4 flex items-center gap-3 animate-in slide-in-from-bottom-4 duration-300">
      <div className="w-10 h-10 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center shrink-0">
        <Download className="h-5 w-5 text-primary" />
      </div>
      <div className="flex-1 min-w-0">
        {showIOSInstructions ? (
          <>
            <p className="text-sm font-semibold text-foreground">Add to Home Screen</p>
            <p className="text-xs text-muted-foreground flex items-center gap-1">
              Tap <Share className="h-3 w-3 inline" /> then &quot;Add to Home Screen&quot;
            </p>
          </>
        ) : (
          <>
            <p className="text-sm font-semibold text-foreground">Install Kintsugi</p>
            <p className="text-xs text-muted-foreground">Add to your home screen</p>
          </>
        )}
      </div>
      <div className="flex items-center gap-2 shrink-0">
        {!showIOSInstructions && (
          <Button size="sm" onClick={install} className="h-8 text-xs">
            Add
          </Button>
        )}
        <button
          onClick={dismiss}
          className="p-1 rounded-md text-muted-foreground hover:text-foreground transition-colors"
          aria-label="Dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
